import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import FeedbackCardContext from '../context.js';
import { Container, Row, Title, Paragraph, TextArea, PrimaryButton } from '../styles.js';
import { feedbackIconMap } from '../types.js';

const ReasonStep = ()=>{
    const theme = useContext(ThemeContext);
    const { feedback , reason , reasonRequired , copyConfig , setReason , handleSubmit  } = useContext(FeedbackCardContext);
    const Icon = feedbackIconMap[feedback];
    const stepCopy = copyConfig.steps.Reason[feedback];
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Row, {
        style: {
            paddingBottom: "8px"
        }
    }, /*#__PURE__*/ React.createElement(Icon, {
        size: "16px",
        color: theme.colors.Foreground
    }), /*#__PURE__*/ React.createElement(Title, {
        thin: true
    }, stepCopy.title)), /*#__PURE__*/ React.createElement(Paragraph, null, stepCopy.subtitle)), /*#__PURE__*/ React.createElement(TextArea, {
        value: reason,
        required: reasonRequired,
        placeholder: stepCopy.placeholder,
        onChange: (e)=>setReason(e.target.value)
    }), /*#__PURE__*/ React.createElement(PrimaryButton, {
        small: true,
        onClick: handleSubmit
    }, stepCopy.submitButton));
};
var ReasonStep$1 = ReasonStep;

export { ReasonStep$1 as default };
